import React from 'react';

import {Modal} from '@optimaxdev/design-system';
import {Exit, Icon} from '@optimaxdev/icons';

import s from './shippingProtectionModal.scss';

const HOW_IT_WORKS = [
    {
        id: 1,
        text: 'Activate Shipping Protection.',
    },
    {
        id: 2,
        text: 'Once shipped, your order is protected!',
    },
    {
        id: 3,
        text: 'Easily file a claim.',
    },
];

type PropsType = {
    isOpen: boolean;
    closePopup: () => void;
};

/**
 * Popup Wrap
 * @param {PropsType} props - component props
 * @returns {React.ReactElement} - Shipping Protection
 */
export const ShippingProtectionModal: React.FC<PropsType> = ({
    closePopup,
    isOpen,
}): React.ReactElement => {
    const shippingProtectionLink = (
        <a
            className={s.link}
            href="https://www.glassesusa.com/terms-and-conditions#SHIPPINGPROTECTION"
            rel="noopener noreferrer"
            target="_blank"
        >
            Shipping Protection Terms of Use.
        </a>
    );

    return (
        <Modal isOpen={isOpen} onRequestClose={closePopup} overlay="dark" withoutCloses>
            <div className={s.popupContent}>
                <button
                    aria-label="Close modal"
                    className={s.closeButton}
                    onClick={closePopup}
                    type="button"
                >
                    <Icon icon={Exit} strokeWidth={2} />
                </button>
                <div className={s.leftSide}>
                    <h1 className={s.title}>Worry-free Shipping Protection</h1>
                    <p className={s.titleDescription}>
                        Choose peace of mind and protect your <br /> shipment from damage, loss, or
                        theft.
                    </p>
                    <h3 className={s.subTitle}>How it works:</h3>
                    <div className={s.howItWorksContainer}>
                        {HOW_IT_WORKS.map(({id, text}) => (
                            <div className={s.typesContainer} key={id}>
                                <div className={s.number}>{id}</div>
                                <p className={s.pointText}>{text}</p>
                            </div>
                        ))}
                    </div>
                    <p className={s.text}>
                        Shipping protection coverage applies to lost, stolen and physically damaged
                        deliveries, subject to the {shippingProtectionLink} Shipping protection
                        coverage is optional. When placing an order that includes shipping
                        protection you confirm such purchase and its terms. Shipping protection fees
                        are non-refundable. For resolved claims, products will be shipped or
                        refunded pending stock availability and subject to the{' '}
                        {shippingProtectionLink} GlassesUSA&apos;s decision is final in all cases.
                        Replacement or refund constitute full settlement and satisfaction of any
                        claim.
                    </p>
                </div>
                <div className={s.rightSide} />
            </div>
        </Modal>
    );
};
